export const emarts = [
  { image: "/images/emart/1.jpg" },
  { image: "/images/emart/2.jpg" },
  { image: "/images/emart/3.jpg" },
  { image: "/images/emart/4.jpg" },
];
